import { put, get } from 'aws-amplify/api';
import { APIResult, convertToFrontEnd, getDefaultAPIHeaders } from './apiUtils';
import { Constants  } from '../helpers';



const DATA_MAPPING = {
    affirmed: "affirmed",
    id: "compound_id",
    appraisalId: "appraisal_id",
    nodeId: "node_id",
    state: "node_state",
    projectId: "project_id",
    revNumber: "revision_number"
}

class AppraisalStateRepository{
    constructor(defaultValues = null){
        this.defaultValues = defaultValues;
    }

    async getAll(appraisalId, projectId){
        try{
            const raw = await getDefaultAPIHeaders();

            // If raw is { headers: {...} }, unwrap it; otherwise use raw as-is
            const flat = raw && typeof raw.headers === 'object' ? raw.headers : raw;

            // Build a pure string→string map (and drop null/undefined)
            const apiHeaders = Object.fromEntries(
            Object.entries(flat ?? {})
                .filter(([, v]) => v != null)
                .map(([k, v]) => [String(k), String(v)])
            );     

            const getOperation = get({ apiName: Constants.API_PATH, 
                                        path: `${Constants.APPRAISAL_STATE_PATH}/${appraisalId}/${projectId}`,
                                        options: { headers: apiHeaders },
                                    });
            const response = await getOperation.response;
            const data = await response.body.json();
            const items = Array.isArray(data) ? data : data?.items ?? [];
            const retVal = items.map(i => {
                let newItem = convertToFrontEnd(DATA_MAPPING, i);

                if(this.defaultValues){
                    newItem = { ...newItem, ...this.defaultValues };
                }

                newItem.projects = [];
                return newItem;
            });
            return new APIResult(false, retVal);
        } catch (err){
            return new APIResult(true, err);
        }
    }

    async getOne(appraisalId, projectId, item){
        try{
            const raw = await getDefaultAPIHeaders();

            // If raw is { headers: {...} }, unwrap it; otherwise use raw as-is
            const flat = raw && typeof raw.headers === 'object' ? raw.headers : raw;

            // Build a pure string→string map (and drop null/undefined)
            const apiHeaders = Object.fromEntries(
            Object.entries(flat ?? {})
                .filter(([, v]) => v != null)
                .map(([k, v]) => [String(k), String(v)])
            );     

            const getOperation = get({ apiName: Constants.API_PATH, 
                                        path: `${Constants.APPRAISAL_STATE_PATH}/${appraisalId}/${projectId}/${item.id}`,
                                        options: { headers: apiHeaders },
                                    });
            const response = await getOperation.response;
            const data = await response.body.json();
            let retVal = convertToFrontEnd(DATA_MAPPING, data);
            //The purpose of this spread is to preserve the values of the item
            // that are front-end only (such as whether or not they are selected)
            // and update the values that are from the back end.
            retVal = { ...item, ...retVal };
            return new APIResult(false, retVal);
        } catch(err) {
            return new APIResult(true, err);
        };
    }

    async updateOne(appraisalId, projectId, nodeId, state, revNumber){
        try{
            const body = {
                appraisal_id: appraisalId,
                project_id: projectId,
                node_id: nodeId,
                node_state: state,
                revision_number: revNumber
            }

            const raw = await getDefaultAPIHeaders(body);

            // If raw is { headers: {...} }, unwrap it; otherwise use raw as-is
            const flat = raw && typeof raw.headers === 'object' ? raw.headers : raw;

            // Build a pure string→string map (and drop null/undefined)
            const apiHeaders = Object.fromEntries(
            Object.entries(flat ?? {})
                .filter(([, v]) => v != null)
                .map(([k, v]) => [String(k), String(v)])
            );

            const putOperation = put({ apiName: Constants.API_PATH, 
                                        path: Constants.APPRAISAL_STATE_PATH,
                                        options: { headers: apiHeaders, body }
                        });
            const { body: putBody } = await putOperation.response;
            const data = await putBody.json();
            const list = Array.isArray(data) ? data : data?.items ?? [];

            const retVal = list.map(d => convertToFrontEnd(DATA_MAPPING, d));
            return new APIResult(false, retVal);
        } catch(err) {
            return new APIResult(true, err);
        }
    }
}

export { AppraisalStateRepository };